// v7.0: el contador ya no se reinicia en bucle (una cuenta atrás falsa puede considerarse práctica engañosa). Al llegar a 0 se oculta.
document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('[data-countdown]').forEach(function(el){var left=parseInt(el.dataset.countdown||'15',10)*60,timer;function tick(){var m=Math.floor(left/60),s=left%60;el.textContent=m+':'+String(s).padStart(2,'0');if(left<=0){clearInterval(timer);var wrap=el.parentNode;if(wrap)wrap.style.display='none';return}left--}tick();timer=setInterval(tick,1000)})});

// v7.0: resumen de valoraciones junto al título, calculado SOLO con las reseñas publicadas en la sección Reseñas.
(function(){
  function initRatingSummary(){
    var box=document.querySelector('[data-rating-summary]');
    var cards=[].slice.call(document.querySelectorAll('.review-card[data-rating]'));
    if(!box||!cards.length) return;
    var sum=cards.reduce(function(t,c){return t+Math.max(1,Math.min(5,parseInt(c.dataset.rating||'5',10)));},0);
    var avg=sum/cards.length, rounded=Math.round(avg);
    box.querySelector('[data-rating-stars]').textContent='★'.repeat(rounded)+'☆'.repeat(5-rounded);
    box.querySelector('[data-rating-avg]').textContent=avg.toFixed(1).replace('.',',');
    box.querySelector('[data-rating-count]').textContent=cards.length+(cards.length===1?' opinión':' opiniones');
    box.setAttribute('aria-label','Valoración media '+avg.toFixed(1).replace('.',',')+' de 5, '+cards.length+(cards.length===1?' opinión':' opiniones'));
    box.hidden=false;
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initRatingSummary); else initRatingSummary();
})();

// Popups opcionales de actividad y reseñas: activar solo con datos reales
(function(){
  function initSocialProof(){
    var source=document.querySelector('[data-social-proof]');
    var popup=document.querySelector('[data-proof-popup]');
    if(!source||!popup) return;
    if(source.dataset.mobile==='false' && window.matchMedia('(max-width: 850px)').matches) return;
    var items=[].slice.call(source.querySelectorAll('[data-proof-item]'));
    if(!items.length) return;
    var delay=parseInt(source.dataset.delay||'5000',10);
    var interval=parseInt(source.dataset.interval||'12000',10);
    var duration=parseInt(source.dataset.duration||'5000',10);
    var index=0, hideTimer=null, loopTimer=null;
    var title=popup.querySelector('[data-proof-title]');
    var message=popup.querySelector('[data-proof-message]');
    var stars=popup.querySelector('[data-proof-stars]');
    var avatar=popup.querySelector('[data-proof-avatar]');
    var close=popup.querySelector('[data-proof-close]');

    function hide(){
      popup.classList.remove('is-visible');
      window.setTimeout(function(){popup.hidden=true;},260);
    }
    function show(){
      var item=items[index%items.length]; index++;
      var kind=item.dataset.kind||'purchase';
      var who=item.dataset.name||'Cliente';
      var where=item.dataset.location ? ' · '+item.dataset.location : '';
      title.textContent=who+where;
      message.textContent=item.dataset.message||'';
      if(kind==='review'){
        var n=Math.max(1,Math.min(5,parseInt(item.dataset.stars||'5',10)));
        stars.textContent='★'.repeat(n)+'☆'.repeat(5-n);
        stars.hidden=false;
        avatar.textContent='★';
      }else{
        stars.hidden=true;
        avatar.textContent='✓';
      }
      popup.hidden=false;
      requestAnimationFrame(function(){requestAnimationFrame(function(){popup.classList.add('is-visible');});});
      clearTimeout(hideTimer); hideTimer=setTimeout(hide,duration);
    }
    if(close) close.addEventListener('click',hide);
    setTimeout(function(){show(); loopTimer=setInterval(show,interval);},delay);
    window.addEventListener('beforeunload',function(){clearInterval(loopTimer);clearTimeout(hideTimer);});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initSocialProof); else initSocialProof();
})();

// v7.2: pago rápido y medible.
// Antes: vaciar carrito + añadir + espera de 180 ms (3 pasos).
// Ahora: 1 sola petición al endpoint nativo /cart/add.js y salto directo a /checkout.
// Shopify registra esa petición como "añadido al carrito" (Analytics y píxeles/Meta/Google
// conectados por canales de venta) y el checkout registra "checkout iniciado" y la compra.
// Si el cliente ya tenía la guía en el carrito, se deja en 1 unidad (no se cobra doble).
(function(){
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  function post(path, body){
    return fetch(root+path,{method:'POST',credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(body)
    }).then(function(r){if(!r.ok) throw new Error('HTTP '+r.status); return r.json();});
  }
  function buy(form){
    var input=form.querySelector('input[name="id"]');
    var id=input?Number(input.value):0;
    if(!id) return Promise.reject(new Error('Variant missing'));
    return post('cart/add.js',{items:[{id:id,quantity:1}]})
      .then(function(res){
        var line=(res.items||[])[0];
        if(line && line.quantity>1) return post('cart/change.js',{id:line.key,quantity:1});
      })
      .then(function(){ window.location.assign(root+'checkout'); });
  }
  document.addEventListener('submit',function(e){
    var form=e.target.closest&&e.target.closest('form.js-native-product-form');
    if(!form) return;
    e.preventDefault();
    if(form.dataset.processing==='true') return;
    form.dataset.processing='true';
    var btn=form.querySelector('button[type="submit"]');
    var old=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.setAttribute('aria-busy','true');btn.textContent='Abriendo pago seguro…';}
    buy(form).catch(function(){
      // Respaldo: envío nativo del formulario (return_to=/checkout). También queda registrado.
      form.dataset.processing='false';
      if(btn){btn.disabled=false;btn.removeAttribute('aria-busy');btn.textContent=old;}
      HTMLFormElement.prototype.submit.call(form);
    });
  },true);
  // Si el cliente vuelve atrás desde el checkout, reactivar los botones.
  window.addEventListener('pageshow',function(ev){
    if(!ev.persisted) return;
    document.querySelectorAll('form.js-native-product-form').forEach(function(f){
      f.dataset.processing='false';
      var b=f.querySelector('button[type="submit"][aria-busy]');
      if(b){b.disabled=false;b.removeAttribute('aria-busy');}
    });
  });
})();
